export function calcMaxEndGameScreenWidth() {
    var maxW = Math.min(window.innerWidth - 20, 400);
    var maxH = window.innerHeight - 230;
    var curH = maxW + maxW * 0.33;
    if (curH > maxH) {
        maxW = maxH - Math.floor(maxH * 0.33);
    }
    return maxW;
}
